import { useParams } from "react-router";
import DocumentForm from "./DocumentForm";

export default function NewVehicleDocument() {
  const { id } = useParams();
  return <DocumentForm ownerType={"VEHICLE"} ownerId={id} />;
}
